import '../App.css';
import {FaReact} from "react-icons/fa";
import {SiJavascript} from "react-icons/si";
import {AiFillHtml5} from "react-icons/ai";
import {IoLogoCss3} from "react-icons/io";
import {IoLogoNodejs} from "react-icons/io";
import {DiMongodb} from "react-icons/di";
import {SiExpress} from "react-icons/si";
import {FaWordpress} from "react-icons/fa";

function TechIcon({ data }) {
    switch (data) {
        case "React":
            data = <FaReact/>;
            break;
        case "NodeJS":
            data = <IoLogoNodejs/>;
            break; 
        case "Express":
            data = <SiExpress/>;            
            break; 
        case "MongoDB":
            data = <DiMongodb/>;      
            break;  
        case "HTML":
            data = <AiFillHtml5/>;
            break;
        case "CSS":
            data = <IoLogoCss3/>
            break;
        case "JavaScript":
            data = <SiJavascript/>;
            break;
        case "Wordpress":
            data = <FaWordpress/>;
            break;
        default:
            break;
    }
    return (
        <div className='Tech-Icon'>
            {data}
        </div>
    )
}

export default TechIcon;